var base = require('settings/teams/create-team');

Vue.component('spark-create-team', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/create-team.js